import { jsxs as g, jsx as r } from "react/jsx-runtime";
import { Box as l } from "@chakra-ui/react";
import "react";
import { Text as a } from "../text/text.js";
import { ThemeRadiusVariable as i, ThemeSpaceVariable as n, ThemeColorVariable as e, ThemeFontSizeVariable as d } from "../../theme/theme-types.js";
function L({
  children: S,
  time: t,
  from: u,
  author: c,
  autoFloat: b,
  errorState: m,
  errorMessage: f,
  ...p
}) {
  const o = c == null || c === "you";
  return /* @__PURE__ */ g(l, { ...p, alignSelf: b ? o ? "flex-start" : "flex-end" : void 0, children: [
    /* @__PURE__ */ g(
      l,
      {
        bg: o ? e.BackgroundDisabled : e.Accent,
        opacity: m ? "0.48" : "1",
        px: n.Medium,
        py: n.Small,
        borderTopRightRadius: i.Large,
        borderTopLeftRadius: i.Large,
        borderBottomRightRadius: o ? i.Large : void 0,
        borderBottomLeftRadius: o ? void 0 : i.Large,
        children: [
          /* @__PURE__ */ r(
            a,
            {
              fontSize: d.Medium,
              color: o ? e.OnBackground : e.OnAccent,
              children: S
            }
          ),
          u && /* @__PURE__ */ r(
            a,
            {
              fontSize: d.Small,
              color: o ? e.OnBackgroundSubdued : e.InfoContainer,
              children: u
            }
          )
        ]
      }
    ),
    t && /* @__PURE__ */ r(l, { ml: n.Small, children: /* @__PURE__ */ r(
      a,
      {
        fontSize: d.XSmall,
        color: m ? e.Error : e.OnBackgroundSubdued,
        textAlign: o ? void 0 : "right",
        children: f || t
      }
    ) })
  ] });
}
export {
  L as Message
};
